/* eslint-disable react/prop-types */
import { IconButton } from '@mui/material';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { useHover } from '@hooks';
import classes from './index.module.css';

export const ClaimOption = ({
  icon = '',
  title = '',
  hoverText = '',
  onClick,
}) => {
  const [hoverRef, isHovered] = useHover();

  return (
    <section className={classes.option} ref={hoverRef} onClick={onClick}>
      <section className={classes.left}>
        {icon ? <img className={classes.icon} src={icon} alt="" /> : null}
        {title ? <section className={classes.title}>{title}</section> : null}
      </section>
      <section onClick={onClick} className={classes.btn}>
        {hoverText ? (
          <section className={classes.hover_text}>
            <section className={classes.hover_text_tip}>
              {hoverText}
            </section>
            <section className={classes.hover_triangle} />
          </section>
        ) : null}
        <IconButton
          aria-label=""
          size="medium"
          color="dark"
          sx={{
            color: isHovered ? '#645AFF' : '#5C5F62',
          }}
        >
          <ArrowCircleRightIcon fontSize="large" />
        </IconButton>
      </section>
    </section>
  );
};
